import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private _token = new BehaviorSubject<string | null>(null);

  // Observable pour s'abonner aux changements
  get token$(): Observable<string | null> {
    return this._token.asObservable();
  }

  // Getter synchrone (utile pour guards/interceptors)
  get currentToken(): string | null {
    return this._token.value;
  }

  constructor(private userService: UserService) {
    const localToken = localStorage.getItem('token');
    if (localToken) {
      this._token.next(localToken);
    }
  }

  login(token: string) {
    this._token.next(token);
    localStorage.setItem('token', token);
    this.userService.loadProfile().subscribe();
  }

  logout() {
    this._token.next(null);
    localStorage.removeItem('token');
    this.userService.clearProfile();

  }
}
